import { render } from "./xxlr.vue?vue&type=template&id=83d5ec0c&scoped=true"
import script from "./xxlr.vue?vue&type=script&lang=js"
export * from "./xxlr.vue?vue&type=script&lang=js"

import "./xxlr.vue?vue&type=style&index=0&id=83d5ec0c&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83d5ec0c"]])

export default __exports__